/* eslint-disable */ 
import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import "./style.css";
import { message, Select, Empty, Spin } from "antd";
import "antd/dist/antd.css";
import "react-input-range/lib/css/index.css";

import { useFormik } from "formik";
import userImage from "../../../assets/images/userimg.jpg";
import DefaultAvatar from "../../../assets/images/defaultAvatar.jpeg";
import messageIcon from "../../../assets/images/msg-iconwhite.png";
import getUserInfo from "../../../shared/Helpers/getUserInfo";
import LoaderUi from "../../../UiLoader/Loader";
import InputRange from 'react-input-range';
import { countries } from '../../../shared/countriesData/CountriesData';
import { timezone } from '../../../shared/timeZoneData/TimeZone';
import { GET, POST } from '../../../apiClient';
import toast from "toasted-notes";
import "toasted-notes/src/styles.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
  useHistory,
} from "react-router-dom";
import moment from 'moment';


const FindTutor = () => {
  let { path } = useRouteMatch();
  let history = useHistory();
  const { Option } = Select;
  const [isAllTutors, setAllTutor] = useState([]);
  const [isPriceRange, setPriceRange] = useState({ min: 0, max: 100 });
  const [isFilterContactList, setFilterContactList] = useState([]);
  const [isUserInfo, setUserInfo] = useState({});
  const [isInvitedId, setInvitedId] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const [isStatus, setStatus] = useState([]);
  const [isSubjects, setSubjects] = useState([]);
  const [isLanguages, setLanguages] = useState([]);
  const [isGender, setGender] = useState([]);
  const [isCountry, setCountry] = useState("");
  const [isTimeZone, setTimeZone] = useState("");
  const [user, setUser] = useState("");
  const [profileImg, setProfileImg] = useState([]);
  const [isLogin, setLogin] = useState(false);
  const allLanguages = ["English", "Urdu", "Arabic", "French", "Persian"];
  // check user online status Online OR Offline
  const userStatusCheckboxHandler = (e) => {
    let value = e.target.value;
    let checked = e.target.checked;
    
    if (checked && value) {
      setStatus((prevState) => [...prevState, value]);
    } else {
      let update = isStatus.filter((sub) => sub !== value);
      setStatus(update);
    }
  };

  // check user Subjects
  const userSubjectsCheckboxHandler = (e) => {
    let value = e.target.value;
    let checked = e.target.checked;
    
    if (checked && value) {
      setSubjects((prevState) => [...prevState, value]);
    } else {
      let update = isSubjects.filter((lang) => lang !== value);
      setSubjects(update);
    }
  };

  // check user langugaes
  const userLanguagesCheckboxHandler = (e) => {
    let value = e.target.value;
    let checked = e.target.checked;
   
    if (checked && value) {
      setLanguages((prevState) => [...prevState, value]);
    } else {
      let update = isLanguages.filter((sub) => sub !== value);
      setLanguages(update);
    }
  };

  // check user gender
  const userGenderCheckboxHandler = (e) => {
    let value = e.target.value;
    let checked = e.target.checked;
   
    if (checked && value) {
      setGender((prevState) => [...prevState, value]);
    } else {
      let update = isGender.filter((sub) => sub !== value);
      setGender(update);
    }
  };

  // check user Country
  const userCountryHandler = (e) => {
    let value = e.target.value;
    
    value && setCountry(value);
  };

  // check user timezone
  const userTimeZoneHandler = (e) => {
    let value = e.target.value;

    value && setTimeZone(value);
  };

  const setUserName = async () => {
    const userInfo = await localStorage.getItem("userInfo");
    const name = JSON.parse(userInfo);
    setUser(name.username);
    setLogin(true);
  };

  const initialValues = {
    status: [],
    subjects: [],
    gender: [],
    langugaes: [],
    hourlyRate: [],
    country: "",
    timeZone: "",
  };

  const onSubmit = async () => {
    let data = {
      status: isStatus,
      subjects: isSubjects,
      gender: isGender,
      languages: isLanguages,
      hourlyRate: isPriceRange,
      country: isCountry,
      timeZone: isTimeZone,
    };
    // Object.keys(data).forEach((key) => (data[key] == '') && delete data[key]); use if you want to remove the empty data
    console.log("filtered values:", data);

    try {
      let filteredResult = await POST('tutor/filter', data);
      console.log("filtered result", filteredResult.data);
      filteredResult && setFilterContactList(filteredResult.data.data);
    } catch (error) {
      console.log("ERROR!");
    }
  };

  const getAllStudents = async (user) => {
    try {
      let tutors;
      if (user) {
        tutors = await GET(`contact/recommendation/?loginId=${user.loginId}&role=${user.userRole}`);
      } else {
        tutors = await GET('tutor/alltutors');
      }
      console.log("All students", tutors.data.data);
      const allTutorsData = tutors.data.data;
      setAllTutor(allTutorsData);
      setFilterContactList(allTutorsData);
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
  });

  const getAllTutors = async (user) => {
   
    setLoading(true);
    try {
      let tutors;
      if (user) {
        tutors = await GET(`contact/recommendation/?loginId=${user.loginId}&role=${user.userRole}`);
      } else {
        tutors = await GET('tutor/alltutors');
      }
      console.log("All tutors", tutors.data.data);
      const allTutorsData = tutors.data.data;
      setAllTutor(allTutorsData);
      setFilterContactList(allTutorsData);
      const userImg = allTutorsData.map((item) => item.profileImage);
      console.log(userImg)
      setProfileImg(userImg);
      setLoading(false);
    } catch (error) {
      console.log(error);
      toast.notify(
        "Request Timed out. Please check your internet connectivity"
      );
    }
  };

  const searchContact = (e) => {
    let searched = e.target.value;

    const filtered = isAllTutors.filter((contact) => {
      if (searched.length > 0) {
        let search = searched.split(" ");
        console.log("Search", search);
        if (search.length > 0 && search[1] && search[1] != "") {
          return (
            contact.firstName.toLowerCase().indexOf(search[0].toLowerCase()) !==
            -1 &&
            contact.lastName.toLowerCase().indexOf(search[1].toLowerCase()) !==
            -1
          );
        }
        return (
          contact.firstName
            .toLowerCase()
            .indexOf(searched.trim().toLowerCase()) !== -1 ||
          contact.lastName.toLowerCase().indexOf(searched.toLowerCase()) !==
          -1 ||
          contact.city.toLowerCase().indexOf(searched.toLowerCase()) !== -1 ||
          contact.country.toLowerCase().indexOf(searched.toLowerCase()) !== -1
        );
      }

      return isAllTutors;
    });
    setFilterContactList(filtered);
  };

  const sendInvite = async (invitedTo) => {
    try {
      let data = {
        invitedTo,
        invitedBy: isUserInfo.loginId,
        role: isUserInfo.userRole,
        username: user,
      };
      console.log("invitedTo", data);
      const invitation = await await POST('contact', data);
      invitation && setLoading(false);
      console.log("Success", invitation);
      message.loading(`Please wait`).then(() => {
        message.success({
          content: `Invitation sent`,
          style: {
            zIndex: "999999",
            fontSize: "20px",
          },
        });
        setInvitedId(invitedTo);
        getAllTutors(isUserInfo);
      });
    } catch (error) {
      console.log(error);
      message.loading(`Please wait`).then(() => {
        message.warning({
          content: `Error while sending invitation`,
          style: {
            zIndex: "999999",
            fontSize: "20px",
          },
        });
      });
    }
  };

  useEffect(() => {
    // window.scrollTo({
    //   top: 0,
    //   behavior: 'smooth',
    // });
    getUserInfo().then((res) => {
      setUserInfo(res);
      getAllTutors(res);
      if (isLogin === true) {
        setUserName();
      }
    });
  }, []);

  return (
    <>
      <section id="findstudent-page">
        <div className="container-fluid">
          {/* } {isLoading ? <LoaderUi /> : null} {*/}
          <div className="pagerow clearfix">
            <form onSubmit={formik.handleSubmit}>
              <div className="sidebar">
                {/* <h3>
                  Search by filters: &nbsp;&nbsp;{" "}
                  <button className="green-btn" type="submit">
                    Apply Filter
                  </button>
                </h3> */}
                <div>
                  <h3 style={{ alignItems: "center", display: "flex" }}>
                    Search by filters:
                    <button class="green-btn" type="submit">
                      Apply Filter
                    </button>
                  </h3>
                </div>
                <div className="searcfilter-box">
                  <h4>Status</h4>
                  <div className="checkbox-button">
                    <input
                      type="checkbox"
                      className="checkbox-button__input"
                      id="choice1-1"
                      name="status"
                      value="online"
                      checked={isStatus.includes("online")}
                      onChange={userStatusCheckboxHandler}
                    />
                    <span className="checkbox-button__control"></span>
                    <span className="checkbox-button__label">Online</span>
                  </div>
                  <div className="checkbox-button">
                    <input
                      type="checkbox"
                      className="checkbox-button__input"
                      id="choice1-1"
                      name="status"
                      value="offline"
                      checked={isStatus.includes("offline")}
                      onChange={userStatusCheckboxHandler}
                    />
                    <span className="checkbox-button__control"></span>
                    <span className="checkbox-button__label">Offline</span>
                  </div>
                </div>
                <div className="searcfilter-box">
                  <h4>Subjects</h4>
                  <div className="checkbox-button">
                    <input
                      type="checkbox"
                      className="checkbox-button__input"
                      id="choice1-1"
                      name="subjects"
                      value="recitation"
                      checked={isSubjects.includes("recitation")}
                      onChange={userSubjectsCheckboxHandler}
                    />
                    <span className="checkbox-button__control"></span>
                    <span className="checkbox-button__label">Recitation</span>
                  </div>
                  <div className="checkbox-button">
                    <input
                      type="checkbox"
                      className="checkbox-button__input"
                      id="choice1-1"
                      name="subjects"
                      value="arabic"
                      checked={isSubjects.includes("arabic")}
                      onChange={userSubjectsCheckboxHandler}
                    />
                    <span className="checkbox-button__control"></span>
                    <span className="checkbox-button__label">Arabic</span>
                  </div>
                  <div className="checkbox-button">
                    <input
                      type="checkbox"
                      className="checkbox-button__input"
                      id="choice1-1"
                      name="subjects"
                      value="hifz"
                      checked={isSubjects.includes("hifz")}
                      onChange={userSubjectsCheckboxHandler}
                    />
                    <span className="checkbox-button__control"></span>
                    <span className="checkbox-button__label">Hifz</span>
                  </div>
                  <div className="checkbox-button">
                    <input
                      type="checkbox"
                      className="checkbox-button__input"
                      id="choice1-1"
                      name="subjects"
                      value="tajweed"
                      checked={isSubjects.includes("tajweed")}
                      onChange={userSubjectsCheckboxHandler}
                    />
                    <span className="checkbox-button__control"></span>
                    <span className="checkbox-button__label">Tajweed</span>
                  </div>
                  <div className="checkbox-button">
                    <input
                      type="checkbox"
                      className="checkbox-button__input"
                      id="choice1-1"
                      name="subjects"
                      value="islamicStudies"
                      checked={isSubjects.includes("islamicStudies")}
                      onChange={userSubjectsCheckboxHandler}
                    />
                    <span className="checkbox-button__control"></span>
                    <span className="checkbox-button__label">
                      Islamic Studies
                    </span>
                  </div>
                </div>
                <div className="searcfilter-box">
                  <h4>Spoken Languages</h4>
                  {allLanguages.map((language, i) => (
                    <div className="checkbox-button">
                      <input
                        type="checkbox"
                        className="checkbox-button__input"
                        id="choice1-1"
                        name="languages"
                        value={language}
                        checked={isLanguages.includes(`${language}`)}
                        onChange={userLanguagesCheckboxHandler}
                      />
                      <span className="checkbox-button__control"></span>
                      <span className="checkbox-button__label">{language}</span>
                    </div>
                  ))}
                </div>
                <div className="searcfilter-box">
                  <h4>Gender</h4>
                  <div className="checkbox-button">
                    <input
                      type="checkbox"
                      className="checkbox-button__input"
                      id="choice1-1"
                      name="gender"
                      value={"Male"}
                      checked={isGender.includes(`Male`)}
                      onChange={userGenderCheckboxHandler}
                    />
                    <span className="checkbox-button__control"></span>
                    <span className="checkbox-button__label">Male</span>
                  </div>
                  <div className="checkbox-button">
                    <input
                      type="checkbox"
                      className="checkbox-button__input"
                      id="choice1-1"
                      name="gender"
                      value={"Female"}
                      checked={isGender.includes(`Female`)}
                      onChange={userGenderCheckboxHandler}
                    />
                    <span className="checkbox-button__control"></span>
                    <span className="checkbox-button__label">Female</span>
                  </div>
                </div>
                <div className="searcfilter-box">
                  <h4>Hourly Rate</h4>
                  <div className="range-slider">
                    <InputRange
                      maxValue={100}
                      minValue={0}
                      formatLabel={(value) => `${value} $`}
                      value={isPriceRange && isPriceRange}
                      onChange={(value) => setPriceRange(value)}
                    />
                  </div>
                </div>
                {/* Hide Rating filter */}
                {/* <div className="searcfilter-box" >
                                <h4>Ratings</h4>
                                <div className="checkbox-button">
                                    <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" />
                                    <span className="checkbox-button__control"></span>
                                    <span className="checkbox-button__label">4.5 & Above</span>
                                </div>
                                <div className="checkbox-button">
                                    <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" />
                                    <span className="checkbox-button__control"></span>
                                    <span className="checkbox-button__label">4.0 & Above</span>
                                </div>
                                <div className="checkbox-button">
                                    <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" />
                                    <span className="checkbox-button__control"></span>
                                    <span className="checkbox-button__label">3.0 & Above</span>
                                </div>
                                <div className="checkbox-button">
                                    <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" />
                                    <span className="checkbox-button__control"></span>
                                    <span className="checkbox-button__label">2.0 & Above</span>
                                </div>
                                <div className="checkbox-button">
                                    <input type="checkbox" className="checkbox-button__input" id="choice1-1" name="choice1" />
                                    <span className="checkbox-button__control"></span>
                                    <span className="checkbox-button__label">1.0 & Above</span>
                                </div>
                            </div>
                             */}
                <div className="searcfilter-box">
                  <h4>Country</h4>
                  <select onChange={userCountryHandler}>
                    <option value="default">Select country</option>
                    {countries.map((country) => (
                      <option key={country.code} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="searcfilter-box">
                  <h4>Timezone</h4>
                  <select onChange={userTimeZoneHandler}>
                    <option value="default">Select timezone</option>
                    {timezone.map((tmz) => (
                      <option value={tmz.text}>{tmz.text}</option>
                    ))}
                  </select>
                </div>
              </div>
            </form>
            <div className="maincontent">
              <div className="searchsection">
                <span>
                  <i className="fas fa-search"></i>
                  <input
                    type="text"
                    placeholder="Search Contact"
                    onChange={searchContact}
                  />
                  {/* <button type="submit" className="default-btn">SEARCH</button> */}
                </span>
                {/* <a href="#">How to find best Quran teacher?</a> */}
              </div>
              {isLoading === true ? (
                <div className="example">
                  <Spin size="large" />
                </div>
              ) : isFilterContactList ? (
                isFilterContactList.map(
                  (tutor, index) =>
                    tutor.firstName && (
                      <div
                        key={index}
                        className="sessionstab-content tutorfind"
                        style={{cursor:'pointer'}}
                      >
                        <div className="reusedbox-content clearfix">
                          <div className="image-wrap" style={{position:'relative'}}>
                            <img
                              src={
                                tutor?.profileImage &&
                                tutor?.profileImage[0]?.profileImage
                                || DefaultAvatar
                              }
                              alt=""
                            />
                             {/* {tutor.isOnline === true ? <span className="online" style={{top:'5px'}}></span> : <span className="offline"></span>} */}
                          </div>
                          <div className="boxcontent w-100">
                            <h4>
                              {tutor.firstName ? tutor.firstName : "Tutor"}{" "}
                              {tutor.lastName}
                            </h4>
                            {/* <ul className="starrating">
                                                    <li className="fa fa-star checked"></li>
                                                    <li className="fa fa-star checked"></li>
                                                    <li className="fa fa-star checked"></li>
                                                    <li className="fa fa-star checked"></li>
                                                    <li className="fa fa-star checked"></li>
                                                </ul> */}
                            <span>Can Teach:</span>
                            {tutor.subjects.map((subject, index) => (
                              <em className="listItem" key={index}>
                                {subject}, &nbsp;
                              </em>
                            ))}
                            <br />
                            <p>* Assalamu Alikum. {tutor.about}</p>
                            <span>Spoken Languages:</span>
                            {tutor.languages.map((language, index) => (
                              <em className="listItem" key={index}>
                                {language}, &nbsp;
                              </em>
                            ))}
                            <br />
                            <span>Time Zone:</span>
                            <em>{tutor.timeZone}</em>
                            <br />
                            <span>Gender:</span>
                            <em>{tutor.gender}</em>
                            <br />
                            <span>Sect:</span>
                            <em>{tutor.sect}</em>
                            <br />
                            <span> City: </span>
                            <em> {tutor.city} </em> <br />
                            <div className="rate-section">
                              <ul>
                                <li>
                                  <em>Hourly Rate:</em>
                                  <span>${tutor.hourlyRate}/hr</span>
                                </li>

                                {tutor?.totalSessions?
                                <li>
                                  <em>Sessions Conducted:</em>
                                  <span>{tutor.totalSessions}</span>
                                </li>
                                :null}

                                {tutor?.lastOnline ? 
                                
                                <li>
                                  <em>Last Online:</em>
                                  <span>{moment(tutor.lastOnline *1000).fromNow()}</span>
                                </li>
                                :null}

                                {tutor?.studentToughts ?
                                <li>
                                  <em>Total Student:</em>
                                  <span>{tutor.studentToughts} Students</span>
                                </li>
                                :null}


                              </ul>

                            </div>
                            <div>
                            {isUserInfo && isUserInfo.userRole !== "tutor" && (
                              <>
                              <a
                                className="green-btn "
                                onClick={() => sendInvite(tutor.userId)}
                              >
                                Send Invitation
                              </a>
                              <a style={{marginRight:'5px'}}
                                className="green-btn "
                                onClick={()=>history.push(`${path}/${tutor.userId}`)}
                              >
                                View Profile
                              </a>
                              </>
                            )}
                            </div>
                          </div>
                          {/* <div className="box-otherlinks">
                            <ul>
                              <li>
                                <a href="#" className="bluebox">
                                  <img src={messageIcon} alt="" />
                                </a>
                              </li>
                            </ul>
                            
                          </div> */}
                        </div>
                      </div>
                    )
                )
              ) : (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={"Sorry no record found"}
                    />
                  )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FindTutor;
